
import { Vue, Component, Prop } from 'vue-property-decorator'
import Column from '@/types/column'
import { capitalize } from '@/globalFunctions'
import { upperFirst } from 'lodash'

@Component({
  components: {}
})

export default class ColumnOptions extends Vue {
  @Prop({ required: true }) columns!: Column[]
  @Prop({ required: true }) storeReference!: string

  modalVisible = false

  get storeName (): string {
    return this.storeReference.split('/')[0] || this.storeReference
  }

  get storeModule (): string | null {
    const parts = this.storeReference.split('/')
    return parts.length > 1 ? parts[1] : null
  }

  get inactiveColumns (): string[] {
    if (this.storeReference.includes('/')) {
      return this.$store.getters[`${this.storeReference}`]
    }
    return this.$store.getters[this.storeReference] || []
  }

  get buttonTitle (): string {
    return this.inactiveColumns.length
      ? this.inactiveColumns.length + ' verborgen ' + (this.inactiveColumns.length > 1 ? 'kolommen' : 'kolom')
      : 'Tabel configuratie'
  }

  closeModal (): void {
    this.modalVisible = false
  }

  toggleColumn (e: any, column: string): void {
    const { inactiveColumns } = this
    if (!e.target.checked) {
      inactiveColumns.push(column)
    } else {
      const index = inactiveColumns.indexOf(column, 0)
      if (index > -1) {
        inactiveColumns.splice(index, 1)
      }
    }
    this.$store.dispatch(`${this.storeModule ? this.storeName + '/set' : 'set' + this.storeName}${upperFirst(this.storeModule || '')}`, inactiveColumns)
  }
}
